import { Component, input } from "@angular/core";
import { Popover } from "primeng/popover";

@Component({
    selector: "kno2-info-popover",
    imports: [Popover],
    template: `
        <i
            class="pi pi-info-circle border-0 mr-0"
            [class]="iconClass()"
            (mouseenter)="op.toggle($event)"
            (mouseleave)="op.hide()"></i>
        <p-popover
            #op
            appendTo="body"
            [baseZIndex]="10000">
            <div class="info-popover-content">
                <div class="info-popover-title">{{ title() }}</div>
                <div [innerHTML]="content()"></div>
            </div>
        </p-popover>
    `,
    styles: `
        i {
            cursor: pointer;
            color: var(--p-surface-300);
        }
        .info-popover-content {
            max-width: 400px;
        }
        .info-popover-title {
            font-weight: 600;
            margin-bottom: 0.5rem;
        }
    `
})
export class InfoPopoverComponent {
    public title = input<string>("Tip");
    public content = input.required<string>();
    public iconClass = input<string>();
}
